import { FC } from 'react'

type Props = {
  color?: string
  className?: string
  fill?: string
}

const PreadviceStatus: FC<Props> = ({ className, color, fill }) => {
  return (
    <svg
      className={className}
      width="51"
      height="46"
      viewBox="0 0 51 46"
      fill={fill || 'none'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M45.5707 17.6699V44.4899H4.9707V17.6699"
        stroke={color || '#221F20'}
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M4.92 17.67H1L25.23 1L49.54 17.58L45.53 17.67"
        stroke={color || '#221F20'}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M41.6711 20.9399H8.87109V44.4899H41.6711V20.9399Z"
        stroke={color || '#221F20'}
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M29.5505 27.34H20.9805V35.91H29.5505V27.34Z"
        stroke={color || '#221F20'}
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M25.2692 35.9099H16.6992V44.4799H25.2692V35.9099Z"
        stroke={color || '#221F20'}
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M33.8395 35.9099H25.2695V44.4799H33.8395V35.9099Z"
        stroke={color || '#221F20'}
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
    </svg>
  )
}

export default PreadviceStatus
